import '@esotericsoftware/spine-pixi-v7'; // Only once, at the top
import { Spine } from '@esotericsoftware/spine-pixi-v7';
import React, { useEffect, useRef } from 'react';
import { initializePixi } from './core/appPixi';

const ScratchPixiApp = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    let app;
    if (containerRef.current) {

      console.log(containerRef.current, 'containerRef.current')
      app = initializePixi(containerRef.current);
    }
    return () => {
      if (app) {
        app.destroy(true, { children: true });
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        margin: 0,
        padding: 0,
        zIndex: 1,
      }}
    />
  );
};

export default ScratchPixiApp;